import React, { useEffect, useState, useRef } from "react";
import { connect } from "react-redux";
import { Grid, Button, Divider, Typography } from "@material-ui/core";
import { Add, Replay, GetApp } from "@material-ui/icons";

import toJs from "../../../hoc/toJS";
import select from "../../../utils/select";

import StudentGuidanceInsertModal from "../StudentGuidanceInsertModal";
import StudentGuidanceExportModal from "../StudentGuidanceExportModal";

import {
  getAllStudentGuidance,
  getAllStudentGuidanceById,
  getFilteredStudentGuidance,
  exportStudentGuidance,
} from "../../../reducer/studentGuidance/action";

function StudentGuidanceButton(props) {
  const { getAllStudentGuidance, getAllStudentGuidanceById, getFilteredStudentGuidance } = props;
  const hasInitialized = useRef(false);

  const [inserting, setInserting] = useState(false);
  const [exporting, setExporting] = useState(false);

  let profileId = props.selectedProfileId;
  if (!profileId) profileId = props.profileDetail?.id;

  useEffect(() => {
    if (props.type !== "all" && profileId && !hasInitialized.current) {
      getAllStudentGuidanceById(profileId);
      hasInitialized.current = true;
    }
  }, [props.type, profileId, getAllStudentGuidanceById]);

  useEffect(() => {
    if (props.type === "all" && props.listFilteredStudentGuidance.length === 0 && !props.isFetching)
      getFilteredStudentGuidance(1, -1, { departmentId: props.department });
  }, []);

  useEffect(() => {
    if (props.type === "all" && !props.isFetching && !props.isFetchingAccepted)
      getFilteredStudentGuidance(1, -1, { departmentId: props.department });
  }, [props.department, getFilteredStudentGuidance]);

  const handleReload = () => {
    if (props.type !== "all") {
      if (profileId) {
        getAllStudentGuidanceById(profileId);
        props.handleReload && props.handleReload();
      }
    } else {
      getFilteredStudentGuidance(1, -1, { departmentId: props.department });
      props.handleReload && props.handleReload();
    }
  };
  const handleInsert = () => setInserting(true);

  const handleExport = () => setExporting(true);

  const handleExportData = async (payload) => {
    await props.exportStudentGuidance(payload);
    setExporting(false);
  };

  return (
    <>
      <Grid container>
        <Grid item xs={6}>
          <Typography variant="h5" style={{ lineHeight: "36px" }}>
            Hướng dẫn sinh viên NCKH
          </Typography>
        </Grid>
        <Grid item xs={6}>
          <div style={{ float: "right" }}>
            <Button variant="outlined" startIcon={<Replay />} onClick={handleReload}>
              Tải lại
            </Button>
            <Button
              variant="contained"
              color="secondary"
              startIcon={<GetApp />}
              style={{ marginLeft: 8 }}
              onClick={handleExport}
            >
              Xuất Excel
            </Button>
            {props.type !== "all" && (
              <Button
                variant="contained"
                color="primary"
                startIcon={<Add />}
                style={{ marginLeft: 8 }}
                onClick={handleInsert}
              >
                Thêm
              </Button>
            )}
          </div>
        </Grid>
      </Grid>
      <Divider style={{ margin: "8px 0" }} />
      <StudentGuidanceInsertModal inserting={inserting} setInserting={setInserting} setUpdating={props.setUpdating} />
      <StudentGuidanceExportModal
        exporting={exporting}
        setExporting={setExporting}
        handleExportData={handleExportData}
      />
    </>
  );
}

const mapStateToProps = (state) => ({
  isFetching: select(state, "studentGuidanceReducer", "isFetching"),
  isFetchingAccepted: select(state, "studentGuidanceReducer", "isFetchingAccepted"),
  listFilteredStudentGuidance: select(state, "studentGuidanceReducer", "listFiltered"),
  profileDetail: select(state, "profileReducer", "detail"),
});

const mapDispatchToProps = (dispatch) => ({
  getAllStudentGuidance: () => dispatch(getAllStudentGuidance()),
  getAllStudentGuidanceById: (id) => dispatch(getAllStudentGuidanceById(id)),
  getFilteredStudentGuidance: (page, pageSize, payload) =>
    dispatch(getFilteredStudentGuidance(page, pageSize, payload)),
  exportStudentGuidance: (payload) => dispatch(exportStudentGuidance(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(toJs(StudentGuidanceButton));

